import React from 'react';

import { cn } from 'shadcn/lib/utils';

import { getCompanySourceBadgeLabel, getCompanySourceColors } from './companySourceAllocationConfig';

/**
 * @param {Object} props
 * @param {string} [props.className]
 * @param {{ id: number, code: string, displayName: string }} props.companySource
 * @param {number} props.numCases
 */
function AllocationBreakdownSource({ className, companySource, numCases }) {
    const badgeLabel = getCompanySourceBadgeLabel(companySource.code);
    const { backgroundColor, badgeColor, borderColor } = getCompanySourceColors(companySource.code);

    return (
        <div className={cn('rounded-lg border p-3', className)} style={{ backgroundColor, borderColor }}>
            <div className="flex items-center gap-2">
                {badgeLabel ? (
                    <span
                        className="inline-flex items-center justify-center rounded px-1.5 py-0.5 text-xs font-semibold text-white"
                        style={{ backgroundColor: badgeColor }}
                    >
                        {badgeLabel}
                    </span>
                ) : null}
                <span className="text-sm font-semibold text-foreground">{companySource.displayName}</span>
            </div>
            <p className="mt-2 text-sm text-muted-foreground">{numCases} cases</p>
        </div>
    );
}

export { AllocationBreakdownSource };
